export default __webpack_public_path__ + "static/media/android-logo-phone.48713d6f.svg";